<i18n>
{
    "ru": {
        "send_by_email": "Отправить список рекомендаций себе на почту",
        "repeat": "Пройти диагностику еще раз",
        "repeat_text": "При повторном прохождении диагностики, текущая подборка ароматов не сохранится!",
        "send": "Отправить",
        "begin": "Начать диагностику",
        "email_placeholder": "Введите свою почту",
        "subscribe": "Получать новостную рассылку",
        "meta": {
            "title": "Обонятельная диагностика"
        }
    }
}
</i18n>

<template>
    <div class="diagnostic-page" :class="{loading: loading}">
        <Breadcrumb
            class="diagnostic-page__breadcrumbs"
            :items="breadcrumbs" />

        <div class="diagnostic-page__picture">
            <img v-lazy-load :data-src="isDeviceDesktop ? '/img/recommendations.jpg' : '/img/recommendations_m.jpg'" alt="" />
        </div>

        <AromaBox class="diagnostic-page__aromabox" :aromabox="diagnosticAromabox" />

        <template v-if="perfumes.length">

            <div class="diagnostic-page__perfumes">
                <div class="diagnostic-page__perfumes-item"
                    v-for="(perfume, index) in perfumes"
                    :key="index">
                    <BlockDiagnosticOffer :options="perfume" />
                </div>
            </div>

            <div class="diagnostic-page__actions">

                <div class="diagnostic-page__actions-block">
                    <div class="diagnostic-page__actions-icon">
                        <img v-lazy-load data-src="/img/envelop.png" alt="" />
                    </div>
                    <div class="diagnostic-page__actions-title">{{ $t('send_by_email') }}</div>
                    <div class="diagnostic-page__form">
                        <app-form v-slot="{ invalid, handleSubmit }" ref="form">
                            <form @submit.prevent="handleSubmit(onSubmit)">
                                <form-field
                                    rules="required|email"
                                    v-slot="{ errors, failed }"
                                    class="form__field diagnostic-page__form-field"
                                    vid="email">

                                    <div class="form-group" :class="{'form-group_error': failed}">
                                        <input type="text"
                                            v-model="form.email"
                                            @input="onInput"
                                            :placeholder="$t('email_placeholder')"
                                            class="form__input form-group__inner" />
                                    </div>

                                    <span :data-visible="isFailed(failed)" class="form__error">{{ head(errors) }}</span>
                                </form-field>

                                <div class="checkbox diagnostic-page__form-field">
                                    <input v-model="form.subscribe_to_newsletter"
                                        type="checkbox"
                                        id="subscribe_checkbox" />
                                    <label for="subscribe_checkbox">
                                        {{ $t('subscribe') }}
                                        <span>aromo.ru</span>
                                    </label>
                                </div>

                                <ButtonBase
                                    class="diagnostic-page__actions-button"
                                    type="submit"
                                    :disabled="invalid || isSubmitLocked">
                                    {{ $t('send') }}
                                </ButtonBase>
                            </form>
                        </app-form>
                    </div>
                </div>

                <div class="diagnostic-page__actions-block">
                    <div class="diagnostic-page__actions-icon">
                        <img v-lazy-load data-src="/img/good.png" alt="" />
                    </div>
                    <div class="diagnostic-page__actions-title">{{ $t('repeat') }}</div>
                    <div class="diagnostic-page__actions-text">{{ $t('repeat_text') }}</div>
                    <ButtonBase
                        @click.native="onDiagnosticClick"
                        class="diagnostic-page__actions-button"
                        type="button">
                        {{ $t('begin') }}
                    </ButtonBase>
                </div>
            </div>

        </template>

        <div v-else class="diagnostic-page__empty">
            <ButtonBase
                @click.native="showPopup('diagnostic')"
                class="diagnostic-page__actions-button"
                type="button">
                {{ $t('begin') }}
            </ButtonBase>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import head from 'lodash/head';

import { mapGetters } from 'vuex';

import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import AromaBox from '@/components/catalog/aromabox';
import BlockDiagnosticOffer from '@/components/catalog/BlockDiagnosticOffer';
import ButtonBase from '@/components/ui/buttons/ButtonBase';

export default {
    name: 'DiagnosticPage',
    components: {
        Breadcrumb,
        AromaBox,
        BlockDiagnosticOffer,
        ButtonBase
    },
    fetchOnServer: false,
    async fetch(){
        if(localStorage.getItem('diagnostics')){
            const parsedDiagnostic = JSON.parse(localStorage.getItem('diagnostics'));
            this.diagnosticId = get(parsedDiagnostic, '[0].id', null);

            await this.$api.get('/users/personalized-sets/' + this.diagnosticId).then(results => {
                this.perfumes = get(results, 'data.perfumes', []).slice(0,10);
                this.loading = false
            })
        }else{
            this.startDiagnostic = true
        }
    },
    asyncData({ app, error }){
        const baseUrl = app.i18n.__baseUrl
        const catalogHref = app.router.resolve({
            name: 'Diagnostic'
        }).href

        const breadcrumbs = [
            {
                path: baseUrl,
                name: app.i18n.t('breadcrumbs.perfumes'),
            },
            {
                path: baseUrl + catalogHref,
                name: app.i18n.t('breadcrumbs.diagnostic'),
            }
        ];

        const requests = [
            app.$api.get('/groups/aroma-boxes'),
        ]

        return Promise.all(requests).then(results => {
            const diagnosticAromabox = get(results, '[0].data', [])

            return {
                breadcrumbs,
                diagnosticAromabox
            }
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });
    },
    globalBus: {
        async 'diagnostic-saved'(){
            await this.$fetch()
        }
    },
    data(){
        return {
            breadcrumbs: [],
            diagnosticAromabox: [],
            perfumes: [],
            form: {
                email: get(this.$auth, 'user.email', ''),
                subscribe_to_newsletter: 0
            },
            startDiagnostic: false,
            loading: true,
            googleEvents: true,
            diagnosticId: null,
            isSubmitLocked: false
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
    },
    watch: {
        form: {
            deep: true,
            handler(){
                this.$refs.form.validate({silent: true})
            }
        }
    },
    mounted(){
        if(this.startDiagnostic || get(this.$route, 'query.action') === 'start')
            this.$nextTick(() => {
                this.showPopup('diagnostic')
                this.loading = false
            })
    },
    methods: {
        head,
        isFailed(failed) {
            return failed;
        },
        onInput(){
            this.form.email = this.form.email.trim();
        },
        async onSubmit() {
            this.isSubmitLocked = true;
            await this.$api.post(`/users/personalized-sets/${this.diagnosticId}/sent`, {
                email: this.form.email,
                subscribe_to_newsletter: this.form.subscribe_to_newsletter ? 'y' : ''
            }).then(() => {
                this.form.email = null;
                this.form.subscribe_to_newsletter = null;
                this.$refs.form.reset();
                this.gaEventHandler('4_email', 'Отправил на почту')

                this.showPopup('popup-subscription', {
                    typeModal: 'email'
                });
            }).catch((error) => {
                if (error.response.status === 422) {
                    return this.$refs.form.setErrors({
                        'email': this.$t('subscription-already-exists')
                    });
                }else{
                    console.log(error.message);
                    this.$alert.error(this.$t('alerts.error'));
                }
            });

            this.isSubmitLocked = false;
        },
        gaEventHandler(action, label){
            if(this.googleEvents)
                this.$ga.event('diagnostics', action, label)
        },
        onDiagnosticClick(){
            this.showPopup('diagnostic')
            this.gaEventHandler('4_new_diagnostics', 'Новая диагностика')
        }
    },
    head(){
        return {
            title: this.$options.filters.metaSitenameTitle(this.$t('meta.title'))
        }
    }
}
</script>

<style lang="less">
.diagnostic-page{
    margin-bottom: rem(88);

    &.loading{
        // opacity: 0;

        &::before{
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            background-color: @color-white;
            content: '';
            z-index: 999;
        }
    }

    &__aromabox{
        margin-bottom: rem(72);
    }

    &__perfumes{
        display: flex;
        flex-wrap: wrap;
        margin: 0 rem(-10) rem(32);

        &-item{
            flex: 0 0 20%;
            width: 20%;
            padding: 0 rem(10);
            margin-bottom: rem(20);
        }
    }

    &__actions{
        display: flex;
        justify-content: space-between;

        &-block{
            width: rem(521);
            flex: 0 0 rem(521);
            border: rem(1) solid @color-gray-white;
            border-radius: rem(3);
            align-items: center;
            display: flex;
            flex-direction: column;
            padding: rem(31);
        }

        &-icon{
            width: rem(40);
            height: rem(40);
            margin-bottom: rem(32);

            img{
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        &-title{
            font-size: rem(22);
            line-height: rem(29);
            font-weight: 500;
            margin: 0 rem(20) rem(20);
            text-align: center;
        }

        &-text{
            font-size: rem(15);
            line-height: rem(23);
            margin-bottom: rem(20);
            color: @color-gray;
            text-align: center;
        }

        &-button{
            margin-top: auto;
            display: flex;
            width: 100%;
            transform: translate3d(0,0,0);
        }
    }

    &__form{
        align-self: normal;
        margin-top: rem(12);

        &-field{
            margin-bottom: rem(20);

            &.checkbox{
                label{
                    display: inline-block;
                    vertical-align: top;

                    span{
                        color: @color-primary;
                    }
                }
            }
        }
    }

    &__picture{
        height: rem(260);
        margin-bottom: rem(72);

        &>img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    @{mobile} & {
        background-color: @color-white;
        margin-bottom: rem(16);
        padding-bottom: rem(20);

        &__picture{
            margin-bottom: 0;
        }

        &__breadcrumbs{
            margin-bottom: 0;
        }
        
        &__aromabox{
            border-top: rem(1) solid @color-gray-white;
            border-bottom: rem(1) solid @color-gray-white;
            margin-bottom: rem(20);
        }

        &__perfumes{
            padding-left: rem(20);
            padding-right: rem(20);
            margin: 0 0 rem(40);

            &-item{
                width: 50%;
                flex: 0 0 50%;
                margin-bottom: 0;
            }
        }

        &__actions{
            display: block;
            margin: 0;
            padding-left: rem(20);
            padding-right: rem(20);

            &-block{
                width: auto;
                margin-bottom: rem(20);
                padding: rem(20);

                &:last-child{
                    margin-bottom: 0;
                }
            }

            &-icon{
                margin-bottom: rem(20);
            }

            &-title{
                font-size: rem(18);
                line-height: rem(27);
                margin-left: 0;
                margin-right: 0;
            }
        }

        &__empty{
            padding-left: rem(20);
            padding-right: rem(20);
        }
    }
}
</style>